import type { HTMLAttributes } from 'react';
import type * as FontSizes from 'autogen/design-tokens/global/font';
import type { BreakPointsType } from 'variables';

// Extracting the union of numbers from the FontSize keys
type FontSizeKeys = keyof typeof FontSizes;
type StrippedFontSizeUnionAsStrings = FontSizeKeys extends `FontSize${infer Size}` ? Size : never;
export type StrippedFontSizeUnionAsNumbers = StrippedFontSizeUnionAsStrings extends `${infer N extends number}`
    ? N
    : never;

export const availableFontSizeArray = [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 40, 48, 56] as const;
export type availableFontSizeTypes = StrippedFontSizeUnionAsNumbers;
export type breakPointObject<T = availableFontSizeTypes> = BreakPointsType<T>;

export type fontSizeTypes<T extends availableFontSizeTypes = availableFontSizeTypes> =
    | Extract<availableFontSizeTypes, T>
    | BreakPointsType<Extract<availableFontSizeTypes, T>>;

export interface IText extends HTMLAttributes<HTMLElement> {
    size?: fontSizeTypes;
    nowrap?: boolean;
}

export type OverlineFontSizes = fontSizeTypes<10 | 12 | 14>;
